import React from 'react';
import type { MouseEvent } from 'react';
import { Block, Typography } from '@klp/design';
import {
    IconName,
    Illustration,
    Kommunikasjon,
} from '@klp/design/Illustrations';
import type { Theme } from '@material-ui/core';
import {
    Divider,
    ListItem,
    ListItemText,
    ListSubheader,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSendLeverandorReminderMutation } from '../../services/rtkApi';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { leverandorActions } from '@klp/leverandor/store';
import { showToast } from '@klpkonsern/ui';

export type MenuPopperCurrentActivityProps = {
    isCurrentActivitySet?: boolean | undefined;
    prosessInstansId: string | undefined;
};

const styles = (theme: Theme) => ({
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        paddingRight: theme.spacing(2),
    },
});

export const MenuPopperCurrentActivity = (
    props: MenuPopperCurrentActivityProps,
) => {
    const { isCurrentActivitySet = false, prosessInstansId } = props;
    const classes = useKlpStyles({}, styles);
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const [sendReminder, { isLoading }] = useSendLeverandorReminderMutation();

    const handleSendReminder = async (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();

        if (!prosessInstansId) return;

        await sendReminder({ prosessInstansId })
            .unwrap()
            .then(() => {
                showToast({
                    body: t('leverandor.successfulOperation'),
                    type: 'success',
                });
            })
            .catch(() => {
                showToast({
                    body: t('general.error.message'),
                    type: 'error',
                });
            });
    };

    const handleAssignResponsibleUser = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        if (!prosessInstansId) return;
        dispatch(
            leverandorActions.setActiveModal({
                type: 'tildelAnsvarlig',
                prosessInstansId,
            }),
        );
    };

    if (!isCurrentActivitySet) return null;
    return (
        <>
            <Divider />
            <ListSubheader disableSticky={true}>
                {t('leverandor.table.tildelAnsvarlig.ansvarlig')}
            </ListSubheader>
            <ListItem
                dense={true}
                button={true}
                disabled={isLoading}
                onClick={handleSendReminder}
            >
                <Block className={classes.iconContainer}>
                    <Illustration pictogram={Kommunikasjon.EPOST} />
                </Block>
                <ListItemText>
                    <Typography translation="leverandor.table.actionMenuItems.sendReminder" />
                </ListItemText>
            </ListItem>
            <ListItem
                dense={true}
                button={true}
                onClick={handleAssignResponsibleUser}
            >
                <Block className={classes.iconContainer}>
                    <Illustration icon={IconName.PROFILE} />
                </Block>
                <ListItemText>
                    <Typography translation="leverandor.table.actionMenuItems.tildel" />
                </ListItemText>
            </ListItem>
        </>
    );
};
